// <demo-video> (§7.9): vídeo nativo alojado en Shopify, sin autoplay con sonido. Publica video_play y video_progress_50.
class DemoVideo extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;
    const data = { video_id: this.dataset.videoId ?? video.currentSrc, location: this.dataset.location ?? 'pdp' };
    let half = false;
    video.addEventListener('play', () => window.Shopify?.analytics?.publish?.('pawly:video_play', data), { once: true });
    video.addEventListener('timeupdate', () => {
      if (!half && video.duration && video.currentTime / video.duration >= 0.5) {
        half = true;
        window.Shopify?.analytics?.publish?.('pawly:video_progress_50', data);
      }
    });
  }
}

customElements.define('demo-video', DemoVideo);
